module.exports = __webpack_public_path__ + "img/dropzone.67c69851.png";